"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.companyUserActivityRoutePath = void 0;
exports.companyUserActivityRoutePath = '/company/user-activity-report';
